import React from "react";
import { SCIENCE } from "@/data/landing";
import { Reveal } from "@/components/landing/primitives";

export const ScienceSection = () => (
  <section id="science" data-testid="science-section" className="relative py-24 lg:py-32 bg-afwn-green afwn-grain overflow-hidden">
    <div className="absolute -right-32 -top-32 w-96 h-96 rounded-full bg-white/5" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-sm tracking-wider uppercase font-semibold text-afwn-amber">The Science Behind</p>
            <h2 className="mt-3 font-heading font-light tracking-tight text-4xl lg:text-5xl text-white">Grounded in established wellness frameworks</h2>
            <p className="mt-5 text-white/70 text-lg leading-relaxed">Anxiety Fix isn’t guesswork. Every lesson and assistant response draws on established mental-health education frameworks and neuroscience — so you can trust the path you’re on. Educational and wellness support only; not a substitute for professional care.</p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {SCIENCE.map((s, i) => (
            <Reveal key={s.title} i={i}>
              <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-7 h-full hover:bg-white/10 transition-colors duration-300">
                <s.icon size={28} className="text-afwn-amber" />
                <h3 className="mt-4 text-xl font-medium text-white">{s.title}</h3>
                <p className="mt-2 text-white/60 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
